import mixpanel from "mixpanel-browser";

const { REACT_APP_MIXPANEL_TOKEN, NODE_ENV } = process.env;

let hasInitAttempted = false;
let isMixpanelInitialized = false;

const isDevelopment = NODE_ENV !== "production";

const warnNoTokenInDevelopment = (): void => {
  if (!isDevelopment) {
    return;
  }

  // eslint-disable-next-line no-console
  console.warn(
    "[analytics] Mixpanel disabled: REACT_APP_MIXPANEL_TOKEN is not set.",
  );
};

const ensureMixpanelInitialized = (): boolean => {
  if (isMixpanelInitialized) {
    return true;
  }

  initializeMixpanel();
  return isMixpanelInitialized;
};

export const initializeMixpanel = (): void => {
  if (hasInitAttempted) {
    return;
  }

  hasInitAttempted = true;

  if (!REACT_APP_MIXPANEL_TOKEN) {
    warnNoTokenInDevelopment();
    return;
  }
  console.log("mixpanel init with token", REACT_APP_MIXPANEL_TOKEN);
  mixpanel.init(REACT_APP_MIXPANEL_TOKEN, {
    debug: isDevelopment,
    track_pageview: false,
    persistence: "localStorage",
  });

  isMixpanelInitialized = true;
};

export const trackMixpanelEvent = (
  eventName: string,
  props: Record<string, unknown>,
): void => {
  if (!ensureMixpanelInitialized()) {
    return;
  }

  mixpanel.track(eventName, props);
};

export const identifyUser = (
  userId: string,
  traits: Record<string, unknown> = {},
): void => {
  if (!userId || !ensureMixpanelInitialized()) {
    return;
  }

  mixpanel.identify(userId);

  if (Object.keys(traits).length > 0) {
    mixpanel.people.set(traits);
  }
};

export const resetIdentity = (): void => {
  if (!ensureMixpanelInitialized()) {
    return;
  }

  mixpanel.reset();
};

export const __resetMixpanelClientForTests = (): void => {
  hasInitAttempted = false;
  isMixpanelInitialized = false;
};
